

// import React, { useEffect } from 'react';
// import { motion } from 'framer-motion';
// import './Events.css';
// import { useLanguage } from '../context/LanguageContext';
// import Icon from '../components/Icon';

// /* Scroll-reveal hook */
// const useScrollReveal = (selector, options = {}) => {
//   useEffect(() => {
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
//     }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
//     document.querySelectorAll(selector).forEach(el => observer.observe(el));
//     return () => observer.disconnect();
//   }, [selector]);
// };

// /* Cinematic hero */
// const PageHero = ({ pill, title }) => (
//   <div className="events-hero">
//     <div className="events-hero-bg" />
//     <div className="events-hero-overlay" />
//     <div className="events-hero-rays" aria-hidden="true">
//       {[1,2,3,4,5].map(i => <span key={i} className={`hero-ray hero-ray-${i}`} />)}
//     </div>
//     <div className="events-hero-content">
//       <span className="page-hero-pill">{pill}</span>
//       <h1 className="page-hero-title">{title}</h1>
//       <div className="page-hero-divider">
//         <span className="phd-line" /><span className="phd-diamond">◆</span><span className="phd-line" />
//       </div>
//     </div>
//     <div className="page-hero-bottom-line" />
//   </div>
// );

// const Events = ({ setCurrentPage }) => {
//   const { t } = useLanguage();

//   useScrollReveal('.event-scroll-item');
//   useScrollReveal('.memory-scroll-item');
//   useScrollReveal('.engagement-scroll-wrapper');

//   const handleContactClick = () => {
//     setCurrentPage('contact');
//     window.scrollTo({ top: 0, behavior: 'instant' });
//   };

//   const upcomingEvents = [
//     { id: 1, titleKey: 'events.eventItems.mahashivratri.title',    dateKey: 'events.eventItems.mahashivratri.date',    timeKey: 'events.eventItems.mahashivratri.time',    descKey: 'events.eventItems.mahashivratri.description',    typeKey: 'events.eventItems.mahashivratri.type',    icon: 'om' },
//     { id: 2, titleKey: 'events.eventItems.annualYatra.title',      dateKey: 'events.eventItems.annualYatra.date',      timeKey: 'events.eventItems.annualYatra.time',      descKey: 'events.eventItems.annualYatra.description',      typeKey: 'events.eventItems.annualYatra.type',      icon: 'flag' },
//     { id: 3, titleKey: 'events.eventItems.chaitraNavratri.title',  dateKey: 'events.eventItems.chaitraNavratri.date',  timeKey: 'events.eventItems.chaitraNavratri.time',  descKey: 'events.eventItems.chaitraNavratri.description',  typeKey: 'events.eventItems.chaitraNavratri.type',  icon: 'trident' },
//     { id: 4, titleKey: 'events.eventItems.guruPurnima.title',      dateKey: 'events.eventItems.guruPurnima.date',      timeKey: 'events.eventItems.guruPurnima.time',      descKey: 'events.eventItems.guruPurnima.description',      typeKey: 'events.eventItems.guruPurnima.type',      icon: 'lamp' },
//     { id: 5, titleKey: 'events.eventItems.shravanSomvar.title',    dateKey: 'events.eventItems.shravanSomvar.date',    timeKey: 'events.eventItems.shravanSomvar.time',    descKey: 'events.eventItems.shravanSomvar.description',    typeKey: 'events.eventItems.shravanSomvar.type',    icon: 'flower' },
//     { id: 6, titleKey: 'events.eventItems.ganeshChaturthi.title',  dateKey: 'events.eventItems.ganeshChaturthi.date',  timeKey: 'events.eventItems.ganeshChaturthi.time',  descKey: 'events.eventItems.ganeshChaturthi.description',  typeKey: 'events.eventItems.ganeshChaturthi.type',  icon: 'elephant' },
//   ];

//   const pastEvents = [
//     { id: 1, titleKey: 'events.pastEventItems.diwali2025.title', dateKey: 'events.pastEventItems.diwali2025.date', descKey: 'events.pastEventItems.diwali2025.description', image: '/Assets/gallery/san_1.jpg' },
//     { id: 2, titleKey: 'events.pastEventItems.yatra2025.title',  dateKey: 'events.pastEventItems.yatra2025.date',  descKey: 'events.pastEventItems.yatra2025.description',  image: '/Assets/gallery/san_2.jpg' },
//   ];

//   return (
//     <motion.div
//       className="events-page"
//       initial={{ opacity: 0, scale: 0.95 }}
//       animate={{ opacity: 1, scale: 1 }}
//       transition={{ duration: 0.5 }}
//     >
//       <PageHero pill={t('events.pageSubtitle')} title={t('events.pageTitle')} />

//       <div className="container">

//         {/* ── Upcoming Events — parchment scroll each ── */}
//         <section  className="upcoming-section">
//           <h2 className="section-title">{t('events.upcomingEventsTitle')}</h2>
//           <div className="events-header-divider">
//             <span className="dot" /><span className="line" /><span className="dot" />
//           </div>
//           <div  className="events-grid">
//             {upcomingEvents.map((event, index) => (
//               <div style={{ marginTop: "10px", marginBottom: "30px" }} className="event-scroll-item" key={event.id}>
//                 <div className="event-scroll-content">

//                   {/* Icon + Date row */}
//                   <div className="event-scroll-top">
//                     <div className="event-icon-wrap"><Icon name={event.icon} /></div>
//                     <span >{t(event.dateKey)}</span>
//                     <span className={`event-badge ${t(event.typeKey).toLowerCase()}`}>
//                       {t(event.typeKey)}
//                     </span>
//                   </div>

//                   <div className="parchment-divider" />

//                   {/* Title */}
//                   <h3 className="event-scroll-title">{t(event.titleKey)}</h3>

//                   {/* Time */}
//                   <div className="event-time-row">
//                     <Icon name="clock" />
//                     <span>{t(event.timeKey)}</span>
//                   </div>

//                   {/* Description */}
//                   <p >{t(event.descKey)}</p>

//                   {/* Learn more */}
//                   <button className="event-learn-btn" onClick={handleContactClick}>
//                     <span>{t('events.learnMore')}</span>
//                     <span className="arrow-right">→</span>
//                   </button>

//                 </div>
//               </div>
//             ))}
//           </div>
//         </section>

//         {/* ── Past Events — parchment scroll each ── */}
//         <section className="past-section">
//           <h2 className="section-title">{t('events.pastEventsTitle')}</h2>
//           <div className="events-header-divider">
//             <span className="dot" /><span className="line" /><span className="dot" />
//           </div>
//           <div className="memories-grid">
//             {pastEvents.map((event) => (
//               <div className="memory-scroll-item" key={event.id}>
//                 <div className="memory-scroll-content">

//                   {/* Image */}
//                   <div className="memory-img-wrap">
//                     <img src={event.image || '/Assets/home/dev.jpg'} alt={t(event.titleKey)} />
//                     <div className="memory-date-badge">{t(event.dateKey)}</div>
//                   </div>

//                   <div className="parchment-divider" style={{ margin: '14px auto' }} />

//                   <h3 className="memory-scroll-title">{t(event.titleKey)}</h3>
//                   <p >{t(event.descKey)}</p>

//                 </div>
//               </div>
//             ))}
//           </div>
//         </section>

//         {/* ── Engagement — parchment scroll ── */}
//         <section className="engagement-section">
//           <div className="engagement-scroll-wrapper">
//             <div className="engagement-scroll-content">
//               <h3 className="engagement-title">{t('events.wantToParticipate')}</h3>
//               <div className="parchment-divider" />
//               <p >{t('events.participateText')}</p>
//               <button className="engagement-btn" onClick={handleContactClick}>
//                 {t('events.contactUs')}
//               </button>
//             </div>
//           </div>
//         </section>

//       </div>
//     </motion.div>
//   );
// };

// export default Events;








import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import './Events.css';
import { useLanguage } from '../context/LanguageContext';
import Icon from '../components/Icon';

import yatra from '../Icon/Yatra.png';
import shravan from '../Icon/shravan.png';
import poornima from '../Icon/poornima.png';
import kalbhairav from '../Icon/Festival.png';

/* Cinematic hero */
const PageHero = ({ pill, title }) => (
  <div  className="events-hero">
    <div className="events-hero-bg" />
    <div className="events-hero-overlay" />
    <div className="events-hero-rays" aria-hidden="true">
      {[1,2,3,4,5].map(i => <span key={i} className={`hero-ray hero-ray-${i}`} />)}
    </div>
    <div className="events-hero-content">
      <span className="page-hero-pill">{pill}</span>
      <h1 className="page-hero-title">{title}</h1>
      <div className="page-hero-divider">
        <span className="phd-line" /><span className="phd-diamond">◆</span><span className="phd-line" />
      </div>
    </div>
    <div  className="page-hero-bottom-line" />
  </div>
);

const Events = ({ setCurrentPage }) => {
  const { t } = useLanguage();

  /* Scroll reveal observer */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.12 }
    );

    document.querySelectorAll(
      ".event-hcard, .special-program-hcard"
    ).forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const handleContactClick = () => {
    setCurrentPage('contact');
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <motion.div
      className="events-page"
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      <PageHero  pill={t('events.pageSubtitle')} title={t('events.pageTitle')} />

      <div style={{background: "#FFF6F6"}}   className="container">

        {/* ── New Events Section (Card Style) ── */}
        <section style={{background: "#FFF6F6"}} className="events-page-section" id="events">
          <div    className="container">
            <h2 style={{ marginTop: "50px" }} className="section-title">{t('home.festivals.title')}</h2>
            <div className="divider"></div>

            {/* ── Grid 1: Major Annual Festivals ── */}
            <div className="events-group-label">🎪 मुख्य वार्षिक उत्सव</div>
            <div className="events-hgrid">

              <div className="special-program-hcard">
                <div className="event-hicon">
                  <img src={yatra} alt="वार्षिक यात्रा" className="chariot-icon" />
                </div>
                <div className="event-hbody">
                  <div className="event-hdate">{t('home.festivals.annualYatraDate')}</div>
                  <h3>{t('home.festivals.annualYatraTitle')}</h3>
                  <p>{t('home.festivals.annualYatraText')}</p>
                </div>
              </div>

              <div className="special-program-hcard">
                <div className="event-hicon">
                  <img src={shravan} alt="श्रावण महिना" className="chariot-icon" />
                </div>
                <div className="event-hbody">
                  <div className="event-hdate">{t('home.festivals.shravanMonth')}</div>
                  <h3>{t('home.festivals.shravanTitle')}</h3>
                  <p>{t('home.festivals.shravanText')}</p>
                </div>
              </div>

              <div className="special-program-hcard">
                <div className="event-hicon">
                  <img src={poornima} alt="पूर्णिमा" className="chariot-icon" />
                </div>
                <div className="event-hbody">
                  <div className="event-hdate">{t('home.festivals.everyMonth')}</div>
                  <h3>{t('home.festivals.poornimaTitle')}</h3>
                  <p>{t('home.festivals.poornimaText')}</p>
                </div>
              </div>

              <div className="special-program-hcard ">
                <div className="event-hicon">
                  <img src={kalbhairav} alt="कालभैरव अष्टमी" className="chariot-icon" />
                </div>
                <div className="event-hbody">
                  <div className="event-hdate">{t('home.festivals.kalbhairavAshtamiDate')}</div>
                  <h3>{t('home.festivals.kalbhairavAshtamiTitle')}</h3>
                  <p>{t('home.festivals.kalbhairavAshtamiText')}</p>
                </div>
              </div>

            </div>

            {/* ── Grid 2: Other Festivals & Special Days ── */}
            <div className="events-group-label" style={{ marginTop: '40px' }}>🪔 इतर सण व विशेष दिवस</div>
            <div className="special-programs-grid">

              <div className="special-program-hcard">
                <div className="event-hicon event-hicon--emoji">⚔️</div>
                <div className="event-hbody">
                  <div className="event-hdate">आश्विन शुक्ल दशमी</div>
                  <h3>दसरा (विजयादशमी)</h3>
                  <p>दसऱ्याच्या दिवशी भव्य विजयादशमी पूजा व रावण दहन होते. शक्तीची आराधना केली जाते.</p>
                </div>
              </div>

              <div className="special-program-hcard">
                <div className="event-hicon event-hicon--emoji">🌙</div>
                <div className="event-hbody">
                  <div className="event-hdate">माघ शुक्ल पूर्णिमा</div>
                  <h3>माघ पौर्णिमा</h3>
                  <p>मंदिरात विशेष स्नान आणि पूजा होते. भक्त देवाला नैवेद्य अर्पण करतात.</p>
                </div>
              </div>

              <div className="special-program-hcard">
                <div className="event-hicon event-hicon--emoji">🔱</div>
                <div className="event-hbody">
                  <div className="event-hdate">फाल्गुन कृष्ण चतुर्दशी</div>
                  <h3>महाशिवरात्रि</h3>
                  <p>शिवलिंगावर विशेष अभिषेक व रुद्र पूजा होते. रात्रभर भजन-कीर्तन चालते.</p>
                </div>
              </div>

              <div className="special-program-hcard">
                <div className="event-hicon event-hicon--emoji">🎨</div>
                <div className="event-hbody">
                  <div className="event-hdate">फाल्गुन पूर्णिमा</div>
                  <h3>होळी</h3>
                  <p>मंदिरात होळी पेटवली जाते, रंगांची उधळण होते. संध्याकाळी भजन व प्रसाद वाटप.</p>
                </div>
              </div>

              <div className="special-program-hcard">
                <div className="event-hicon event-hicon--emoji">🚩</div>
                <div className="event-hbody">
                  <div className="event-hdate">चैत्र शुक्ल प्रतिपदा</div>
                  <h3>गुडी पाडवा</h3>
                  <p>नवीन वर्षाच्या स्वागतार्थ गुढी उभारली जाते. विशेष पूजा व महाप्रसाद होतो.</p>
                </div>
              </div>

              <div className="special-program-hcard">
                <div className="event-hicon event-hicon--emoji">☀️</div>
                <div className="event-hbody">
                  <div className="event-hdate">रविवार</div>
                  <h3>रविवार विशेष पूजा</h3>
                  <p>प्रत्येक रविवारी मंदिरात विशेष आरती व पूजा होते. महाप्रसाद वाटप केले जाते.</p>
                </div>
              </div>

              <div className="special-program-hcard">
                <div className="event-hicon event-hicon--emoji">🌑</div>
                <div className="event-hbody">
                  <div className="event-hdate">महिन्याची अमावस्या</div>
                  <h3>अमावस्या</h3>
                  <p>पितृ तर्पण व विशेष पूजा होते. शांत वातावरणात भजन व आरती चालते.</p>
                </div>
              </div>

              <div className="special-program-hcard">
                <div className="event-hicon event-hicon--emoji">🪷</div>
                <div className="event-hbody">
                  <div className="event-hdate">सोमवारची अमावस्या</div>
                  <h3>सोमवती अमावस्या</h3>
                  <p>अत्यंत दुर्मिळ व पवित्र दिवस. शिव-विष्णूची विशेष आराधना केली जाते.</p>
                </div>
              </div>

            </div>

            {/* ── Special Program - Single Row Horizontal Cards ── */}
            <div className="events-group-label" style={{ marginTop: '50px' }}>
              📅 सणाच्या दिवशी विशेष कार्यक्रम
            </div>

            <div className="special-programs-grid">
              
              <div className="special-program-hcard">
                <div className="sp-icon">🙏</div>
                <div className="sp-content">
                  <h3>पूजा व नाथांच्या ओव्या</h3>
                  <p className="sp-time">सकाळी ८.३० ते १०.००</p>
                </div>
              </div>

              <div className="special-program-hcard">
                <div className="sp-icon">🎪</div>
                <div className="sp-content">
                  <h3>छबिना</h3>
                  <p className="sp-time">सकाळी १०.३० ते दुपारी १२.००</p>
                </div>
              </div>

              <div className="special-program-hcard">
                <div className="sp-icon">🍛</div>
                <div className="sp-content">
                  <h3>महाप्रसाद</h3>
                  <p className="sp-time">दुपारी १२.०० ते सायंकाळी ५.००</p>
                </div>
              </div>

            </div>

          </div>
        </section>

        {/* ── Engagement Section (Kept as requested) ── */}
        <section className="engagement-section">
          <div className="engagement-scroll-wrapper">
            <div className="engagement-scroll-content">
              <h3 className="engagement-title">{t('events.wantToParticipate')}</h3>
              <div className="parchment-divider" />
              <p >{t('events.participateText')}</p>
              <button className="engagement-btn" onClick={handleContactClick}>
                {t('events.contactUs')}
              </button>
            </div>
          </div>
        </section>

      </div>
    </motion.div>
  );
};

export default Events;



